import { styled } from 'parkdepot-shared/theme'

const Container = styled<'div', { disabled?: boolean }>('div', ({ $theme, disabled }) => ({
    ...$theme.typography.ParagraphMedium,
    cursor: 'pointer',
    fontWeight: 600,
    backgroundColor: '#F6F6F6',
    borderRadius: '14px',
    height: '8rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'center',
    color: disabled ? '#ADADAD' : '#222323'
}))

export default Container
